// source: v1alpha1/common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.pb.v1alpha1.PIPELINE_TYPE', null, global);
/**
 * @enum {number}
 */
proto.pb.v1alpha1.PIPELINE_TYPE = {
  PIPELINE_UNSPECIFIED: 0,
  PIPELINE_SCRIPT_COVERAGE: 1,
  PIPELINE_SCRIPT_GENRE: 2
};

goog.object.extend(exports, proto.pb.v1alpha1);
